import { TFunction } from 'react-i18next'

import { ICustomJoyrideSteps } from '../../joyride.types'

export enum IPenaltySchemeStepIdEnum {
  penaltyScheme_actions = 'penalty_scheme:actions',
  penaltyScheme_fields = 'penalty_scheme:fields',
  penaltyScheme_general = 'penalty_scheme:general',
}

export const PenaltySchemeSteps = (t: TFunction<'translation', undefined>): ICustomJoyrideSteps => {
  return {
    [IPenaltySchemeStepIdEnum.penaltyScheme_general]: [],
    [IPenaltySchemeStepIdEnum.penaltyScheme_actions]: [],
    [IPenaltySchemeStepIdEnum.penaltyScheme_fields]: [
      {
        target: '#penalty_scheme_provider',
        content: t('onboarding.penalty_scheme.common.provider'),
        disableBeacon: true,
      },
      {
        target: '#penalty_scheme_policies',
        content: t('onboarding.penalty_scheme.common.policies'),
        disableBeacon: true,
      },
      {
        target: '#penalty_scheme_time_range',
        content: t('onboarding.penalty_scheme.common.time_range'),
        disableBeacon: true,
      },
    ],
  }
}
